import React from "react";

/* assets */
import GLLogo from "../../../NTICore/assets/img/gl_logo.png";

/** returns a header page */
export const HeaderComponent = () => {
  return (
    <div className="row gl_pushdown">
      <div className="col-lg-6 col-sm-6 col-xs-12 col-md-6 gl_centertop">
        <p>
          <img src={GLLogo} alt={""} style={{width: "300px"}} />
        </p>
      </div>
      <div className="col-lg-6 col-sm-6 col-xs-12 col-md-6 gl_centertop">
        <h3 className="gl_right">LIMITED AGENCY AGREEMENT</h3>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Layout/HeaderComponent.js